import { format, parse, parseISO } from 'date-fns'

const FLORISTONE_DATE_STRING_FMT = 'MM/dd/yyyy'
const HUMAN_READABLE_FMT = 'PPPP'

const intl_time_formatter_options = (timeZone: string): Record<string, string> => ({
  timeZone,
  hour: 'numeric',
  minute: 'numeric',
})
const intl_date_formatter_options = (timeZone: string): Record<string, string> => ({
  timeZone,
  weekday: 'long',
  month: 'long',
  day: 'numeric',
})

export const floristOneToHumanReadable = (dateString: string): string => {
  const date = parse(dateString, FLORISTONE_DATE_STRING_FMT, new Date())

  return format(date, HUMAN_READABLE_FMT)
}

type ISOString = string
export const formatDateFromISOString = (dateString: ISOString, timeZone): string => {
  try {
    const formatter = new Intl.DateTimeFormat([], intl_date_formatter_options(timeZone))
    const date = parseISO(dateString)

    return formatter.format(date)
  } catch (_error) {
    return ''
  }
}

export const formatTimeRangeFromISOStrings = (
  startsAt: ISOString | undefined,
  endsAt: ISOString | undefined,
  timeZone: string,
) => {
  try {
    const startsAtDate = startsAt && parseISO(startsAt)
    const endsAtDate = endsAt && parseISO(endsAt)
    const formatter = new Intl.DateTimeFormat([], intl_time_formatter_options(timeZone))

    if (!startsAtDate) {
      return ''
    }

    if (endsAtDate) {
      return `${formatter.format(startsAtDate)} - ${formatter.format(endsAtDate)}`
    }

    return formatter.format(startsAtDate)
  } catch (_error) {
    return ''
  }
}
